import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Redirect }  from 'components/ReactRouterDomLocalized';

import LoginRedirect from 'components/LoginRedirect'

import MemberIndex from './MemberIndex';
import MessageDialog from './MessageDialog';
import MessageListTrash from './MessageListTrash';
import MessageListMessages from './MessageListMessages';
import MessagePmConversations from './MessagePmConversations';
import MemberAmateurFilms from './MemberAmateurFilms';
import MemberWallPosts from './MemberWallPosts';
import MemberPhotos from './MemberPhotos';
import MemberVirtualGifts from './MemberVirtualGifts';
import MemberGuestbook from './MemberGuestbook';
import MemberPaymentHistory from './MemberPaymentHistory';
import Wallet from './Wallet';
import WalletCharge from './WalletCharge';
import WalletHistory from './WalletHistory';
import WalletReplenish from './WalletReplenish';
import MemberFollowing from './MemberFollowing';
import MemberFollowed from './MemberFollowed';
import MemberBlackList from './MemberBlackList';
import MemberNotificationList from './MemberNotificationList';
import MemberNotificationSetting from './MemberNotificationSetting';

import paths from 'paths';

class Member extends Component {
    constructor(props) {
        super(props);
        const { location } = this.props;

        this.state = {
            logout: false,
            skipAuth: location.pathname.indexOf(paths.memberNotificationSetting.path) !== -1 && !!location.hash
        };
    }

    componentWillReceiveProps(nextProps) {
        let logoutIsDone = this.props.currentUser.isLoggedIn() && !nextProps.currentUser.isLoggedIn();
        this.setState({logout: logoutIsDone});
    }

    render() {
        const { skipAuth } = this.state;  
        const { location, currentUser } = this.props;

        if (!currentUser.isLoggedIn() && !skipAuth) {
            if (this.state.logout) {
                return <Redirect to="/"/>
            } else {
                return <LoginRedirect location={location}/>
            }
        }

        return (
            <div id="wrapper">
                <Route exact path={paths.member.path} component={MemberIndex}/>
                <Route path={paths.memberMessageDialog.path+':id'} component={MessageDialog} />
                <Route path={paths.memberMessageListTrash.path} component={MessageListTrash} />
                <Route path={paths.memberMessageListMessages.path} component={MessageListMessages} />
                <Route exact path={paths.memberMessagePmConversations.path}>
                    <MessagePmConversations filter="conversations" />
                </Route>
                <Route exact path={paths.memberMessagePmRequests.path}>
                    <MessagePmConversations filter="requests"/>
                </Route>
                <Route exact path={paths.memberMessagePmArchive.path}>
                    <MessagePmConversations filter="archive"/>
                </Route>
                <Route exact path={paths.memberMessagePmConversations.path + '/:id'}>
                    <MessagePmConversations filter="conversations" />
                </Route>
                <Route path={paths.memberMessagePmRequests.path + '/:id'}>
                    <MessagePmConversations filter="requests"/>
                </Route>
                <Route path={paths.memberMessagePmArchive.path + '/:id'}>
                    <MessagePmConversations filter="archive"/>
                </Route>
                <Route path={paths.memberAmateurFilms.path} component={MemberAmateurFilms} />
                <Route path={paths.memberWallMaterials.path} component={MemberWallPosts} />
                <Route path={paths.memberAlbum.path} component={MemberPhotos} />
                <Route path={paths.memberVirtualGifts.path} component={MemberVirtualGifts} />
                <Route path={paths.memberGuestbook.path} component={MemberGuestbook} />
                <Route path={paths.memberPaymentHistory.path} component={MemberPaymentHistory} />
                <Route exact path={paths.memberWallet.path} component={Wallet} />
                <Route path={paths.memberWalletCharge.path} component={WalletCharge} />
                <Route path={paths.memberWalletHistory.path} component={WalletHistory} />
                <Route path={paths.memberWalletReplenish.path} component={WalletReplenish} />
                <Route path={paths.memberFollowing.path} component={MemberFollowing} />
                <Route path={paths.memberFollowers.path} component={MemberFollowed} />
                <Route path={paths.memberBlackList.path} component={MemberBlackList} />
                <Route path={paths.memberNotificationList.path} component={MemberNotificationList} />
                <Route path={paths.memberNotificationSetting.path} component={MemberNotificationSetting} />
            </div>
        )
    }
}

const mapStateToProps = state => ({ currentUser: state.currentUser });

export default connect(mapStateToProps)(Member);



// WEBPACK FOOTER //
// ./src/containers/member/Member.js